import React, { Component, Fragment } from 'react';
import axios from 'axios'
import { connect } from 'react-redux';
import { fetchUserNotifications } from "../../../../redux/actions/management_actions";
import FormColumn from '../../../Templates/FormColumn'
import { SORT, toggleSorting } from '../../../Templates/functions'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress';
class HistoryTab extends Component {  
  signal = axios.CancelToken.source()

  state = {
    sortingByMessages: 0,
    sortingByDate: 1,
    isLoading: true
  }
  componentDidMount = () => {
    this.loadData()
  }

  componentWillUnmount = () => {
    this.signal.cancel('Api is being canceled');
  }


  loadData = () => {
    let signalToken = this.signal.token
    Promise.all([
      this.props.fetchUserNotifications(this.props.user.username, signalToken),
    ]).then(([res1]) => {
      this.setState({
        isLoading: false
      })
    }).catch(err => {
      if (axios.isCancel(err)) {
        console.info('User Profile Profile Tab - ', err.message)
      } else {
        console.debug('Error', err.message)
      }
    });
  };

  render() {
      let notifications = this.props.notifications || []

    if (this.state.sortingByMessages) {
      notifications = SORT(this.state.sortingByMessages, notifications, "message")
    }

    if (this.state.sortingByDate) {
      notifications = SORT(this.state.sortingByDate, notifications, "createdAt")
    }

    let messages = []
    let dates = []

    notifications.forEach(notification => {
      messages.push(notification.message)
      dates.push(moment(notification.createdAt).format('MMM Do YYYY, h:mm a'))
    })  
    return <div id="management-user-history" className="overflow flex">
      {this.state.isLoading ?
        <Fragment>
          <CircularProgress />
        </Fragment>
        :
        <Fragment>
          {/* sort={() => toggleSorting(this.state.sortingByMessages, (value) => this.setState({ sortingByMessages: value, sortingByDate: 0 }))} sorting={this.state.sortingByMessages} */}
          <FormColumn title={"Date"} sort={() => toggleSorting(this.state.sortingByDate, (value) => this.setState({ sortingByMessages: 0, sortingByDate: value }))} sorting={this.state.sortingByDate} content={dates} contentType={"text"} columnWidth={"250px"} />
          <FormColumn title={"Activity"}  content={messages} contentType={"text"} columnWidth={"calc(100% - 250px)"}  nullSort={true}/>
        </Fragment>}
    </div>
  }
}

const mSTP = (state) => {
  return ({
    notifications: state.management.user.notifications,
  });
};

const mDTP = (dispatch) => ({
    fetchUserNotifications: (username, cancelToken) => dispatch(fetchUserNotifications(username, cancelToken)),  
  })

export default connect(mSTP, mDTP)(HistoryTab);

